import React, { useCallback, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch } from 'react-redux';

import { handleDocumentDownload } from 'utils/helpers';
import { notificationCreated } from 'reducers/appNotification';

import { Loader } from 'components';
import { Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
    docLink: {
        marginBottom: 15,
        marginTop: 15,
        cursor: 'pointer',
        textDecoration: 'underline',
    },
}));

const DocumentLink = ({
    isDocumentAvailable,
    document,
    label,
    align = 'center',
    margin = 'auto',
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [downloading, setDownloading] = useState(false);

    const setNotification = useCallback(
        msgKey => dispatch(notificationCreated(msgKey)),
        [dispatch]
    );

    const handleDownload = useCallback(() => {
        handleDocumentDownload(document, setDownloading, setNotification);
    }, [document, setNotification]);

    if (!isDocumentAvailable) return null;

    return (
        <Typography
            className={classes.docLink}
            onClick={handleDownload}
            component="span"
            display="block"
        >
            <Box display="flex" justifyContent={align} width="fit-content" margin={margin}>
                <Loader loading={downloading} size={24} marginTop={0}>
                    {label}
                </Loader>
            </Box>
        </Typography>
    );
};

DocumentLink.propTypes = {
    document: PropTypes.object.isRequired,
    isDocumentAvailable: PropTypes.bool,
    label: PropTypes.string,
    align: PropTypes.string,
    margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DocumentLink;
